/**
 * Horaires du chat conseiller. Hors de ces créneaux, on redirige vers le
 * système de ticket (« laisser un message »).
 */
export const SUPPORT_HOURS_LABEL = "Du lundi au vendredi, 9h–19h";
export const SUPPORT_HOURS_SHORT = "Lun–Ven 9h–19h";

/** Conseiller joignable en direct ? (heure locale du navigateur) */
export function isConseillerOnline(d: Date = new Date()): boolean {
  const day = d.getDay(); // 0 = dimanche … 6 = samedi
  const h = d.getHours();
  return day >= 1 && day <= 5 && h >= 9 && h < 19;
}
